import * as React from "react";
import styled from "styled-components";

import {
  dayHours,
  dayMinutes
} from "src/library/utils/time-helpers/time-helpers";
import { Select } from "src/library/components/Forms";
import { Text } from "src/library/components/Text/Text";

interface TimePickerProps {
  setTime: (time: string) => void;
  value?: string;
  name: string;
  timezone: string;
  disabled?: boolean;
  label?: string;
  displayTimezone?: boolean;
  forceSelect?: boolean;
}

/**
 * Component for time selection
 */
export const TimePicker: React.ReactFCWithChildren<TimePickerProps> = ({
  setTime, value, name, timezone, disabled, displayTimezone, label, forceSelect
}) => {
  const { hours, minutes } = React.useMemo(() => {
    if (value) {
      const timeSplit = value.split(":");

      return ({
        hours: timeSplit[ 0 ],
        minutes: timeSplit[ 1 ]
      });
    }

    if (!forceSelect) {
      return ({
        hours: "00",
        minutes: "00"
      });
    }

    return {
      hours: undefined,
      minutes: undefined
    };
  }, [ forceSelect, value ]);

  return (
    // Time cutoff.
    <TimeWrapper>

      <div className="time-inner">
        {label && (
          <div className="label">
            <Text>
              {label}
            </Text>
          </div>
        )}

        <div className="select-box-wrapper">
          <Select
            as="select"
            value={hours ?? ""}
            className="select-box select-box-hour"
            name={`${name}-hours`}
            autoHideLabels
            disabled={disabled}
            label=""
            options={dayHours.map(dayHour => {
              return {
                text: dayHour,
                value: dayHour
              };
            })}
            handleChange={selectProps => {
              setTime(`${selectProps.currentTarget.value}:${minutes ?? "00"}`);
            }}
          />

          <Text weight="bold">
            :
          </Text>

          <Select
            as="select"
            value={minutes ?? ""}
            className="select-box select-box-minute"
            name={`${name}-minutes`}
            disabled={disabled}
            autoHideLabels
            label=""
            options={dayMinutes.map(dayMinute => {
              return {
                text: dayMinute.toString(),
                value: dayMinute.toString()
              };
            })}
            handleChange={selectProps => {
              setTime(`${hours ?? "00"}:${selectProps.currentTarget.value}`);
            }}
          />
        </div>

        {displayTimezone && (
          <Text>
            {`(${timezone})`}
          </Text>
        )}
      </div>
    </TimeWrapper>
  );
};

const TimeWrapper = styled.div`
  .time-inner {
    display: flex;
    flex-direction: column;
    align-items: start;
  }
  
  .label{
    padding-top:15px;
    padding-bottom:5px;
  }

  .select-box-wrapper {
    display: flex;
    align-items: center;
  }


  .select-box {
    width: 90px;

    select {
      min-width: 0;
    }
  }
`;
